import { getSysAreaList } from '@/CommonDP/service/vf-component-service';
import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
import Vue from 'vue';
export const levels = [
  { cnName: '省级行政区', id: 0 },
  { cnName: '地级行政区', id: 1 },
  { cnName: '县级行政区', id: 2 }];
export const CITY_ENUM = {
  baseLevel: 2,
  splitter: '/'
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-city',
  icon: 'tree',
  label: '省市选择',
  formItemFlag: true,
  component: require('./index.vue').default,
  props() {
    const props = {
      setting: () => import('./setting.vue')
    };
    return props;
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ['value', 'label'],
      onValidate: ['rule', 'value', 'callback']
    };
  },
  zh: {
    dict: {
      label: '标签名称'
    }
  },
  options: {
    name: '',
    label: '省市选择',
    requiredHint: ' ',
    labelHidden: false,
    labelWrap: false, // 自动换行
    labelWidth: '',
    required: false,
    disabled: false,
    position: '',
    labelAlign: '',
    columnWidth: '200px',
    // ----
    // defaultDict: undefined,
    setting: '', // 组件引用专用字段
    assignToName: '', // 名称字段
    defaultCity: '',
    showLevel: CITY_ENUM.baseLevel, // 名称样式
    // ----
    customClass: '',
    onValidate: '',
    onMounted: '',
    onChange: '',
    onInitAndUpdate: ""
  }
};
// 城市缓存,防止重复获取
const cache_ = {};
export const cityMap = {};
export async function getArea(pid = 0) {
  const oldFn = cache_[pid];
  const pn = oldFn || getSysAreaList({ pid });
  const { data } = await pn;
  if (oldFn) data.forEach((row) => { Vue.set(cityMap, row.code, row); });
  else { cache_[pid] = pn; }
  return data;
}
